(function () {

  let bookingConfirmed = false;

  window.addEventListener('message', function (e) {
    if (!e.data || typeof e.data !== 'object') return;

    // Booking added to cart signal
    if (e.data.action === 'add_to_cart') {
      bookingConfirmed = true;
    }

    // Modal closing signal — if booking was confirmed, redirect to cart
    if (e.data.action === 'shrink_modal') {
      if (bookingConfirmed) {
        bookingConfirmed = false;
        setTimeout(function () {
          window.location.href = '/cart';
        }, 1200);
      }
    }
  });

})();